import * as turf from '@turf/turf';
import 'regenerator-runtime/runtime';

/**
 * ------------------
 * GeolocationService
 * ------------------
 * gère le service de géolocalisation
 * */
export default class GeolocationService {

    /**
     * -------------------
     * getPosition
     * -------------------
     * Get la position de l'utilisateur
     */
    static async getPosition() {
        const options = {
            enableHighAccuracy: false,
            timeout: 5000,
        }
        return new Promise(async (resolve, reject) => {
            window.navigator.geolocation.getCurrentPosition(
                (position) => {
                    resolve(position.coords)
                },
                (error) => {
                    reject(error)
                },
                options
            );
        });
    }

    /**
     * ---------
     * getCenter
     * ---------
     * Récupère le centre entre 2 coords
     */
    static getCenter = function (coords) {
        const features = turf.featureCollection([
            turf.point(coords[0]),
            turf.point(coords[1])
        ]);
        return turf.center(features);
    }
}